var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.28 12.559"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l6.28 6.279L0 12.558z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2LjI4IiBoZWlnaHQ9IjEyLjU1OSIgdmlld0JveD0iMCAwIDYuMjggMTIuNTU5Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDpjdXJyZW50Q29sb3I7fTwvc3R5bGU+PC9kZWZzPjxwYXRoIGNsYXNzPSJhIiBkPSJNLTc3Ny4wODcsMTE5MTguMTQ4bDYuMjgsNi4yNzktNi4yOCw2LjI3OVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDc3Ny4wODcgLTExOTE4LjE0OCkiLz48L3N2Zz4=";
export { SvgPlay as ReactComponent };